"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.swrConfig = void 0;
const swrConfig = exports.swrConfig = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: false
};
